import {Injectable} from '@angular/core';
import {Router, RouterStateSnapshot} from '@angular/router';
import {AbstractLocalStorageService} from '../common/abstract-local-storage.service';
import {LocalStorageService} from '@dcp/configurator';

export const USER_REGISTRATION_REDIRECT_URL: string = 'userRegistrationRedirectUrl';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationRedirectService extends AbstractLocalStorageService {

  protected currentValue: string;

  constructor(
    protected localStorageService: LocalStorageService,
    private router: Router,
  ) {
    super(localStorageService);
    this.setLocalStorageKey(USER_REGISTRATION_REDIRECT_URL);
  }

  /**
   * Starts user registration flow.
   */
  public registerCurrentUser(routerStateSnapshot?: RouterStateSnapshot): void {
    this.saveCurrentNavigationUrl(routerStateSnapshot);
    this.router.navigateByUrl('/selectionType');
  }

  /**
   * Saves the current url as the redirect url.
   */
  public saveCurrentNavigationUrl(routerStateSnapshot?: RouterStateSnapshot): void {
    if (!routerStateSnapshot) {
      routerStateSnapshot = this.router.routerState.snapshot;
    }
    const url = routerStateSnapshot.url;
    this.currentValue = url;
    this.setStorageValue(url);
  }

  public resetNavigationUrl(): void {
    this.currentValue = undefined;
    this.resetStorageValue();
  }
}
